import { Button } from "@mui/material";
import React from "react";
import ProductsFormModal from "./ProductsFormModal";
import PermissionDeniedWrapper from "../../../components/PermissionDeniedWrapper";
import {usePermissions} from "../../../hooks/usePermissions";
import {useAccessDeniedMessage} from "../../../hooks/useAccessDeniedMessage";
import {CREATE_PRODUCT} from "../../../constants/eInvoicePermissions";

function ProductsListPageActions() {
  const [open, setOpen] = React.useState(false);

    const { hasEInvoicePermission } = usePermissions();
    const accessDeniedMessage = useAccessDeniedMessage();
    const canCreateProduct = hasEInvoicePermission(CREATE_PRODUCT);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <PermissionDeniedWrapper show = {!canCreateProduct}  title={accessDeniedMessage}>
      <Button
        data-testid="add-product-button"
        key="add-new-product"
        variant="contained"
        disabled={!canCreateProduct}
        color="primary"
        onClick={handleClick}
      >
        + Add New
      </Button>
      <ProductsFormModal open={open} handleClose={handleClose} />
    </PermissionDeniedWrapper>
  );
}

export default ProductsListPageActions;
